import { isPlatformServer } from '@angular/common';
import { computed, Directive, inject, InjectionToken, PLATFORM_ID, Provider } from '@angular/core';
import { Store } from '@ngrx/store';
import { DealerFeature } from '../+state';
import { injectScript } from '../utilities/inject-script';

let showroomBtns = 0;

export interface ShowroomBtnConfig {
    scriptUrl: string;
}

export const SHOWROOM_BTN_CONFIG = new InjectionToken<ShowroomBtnConfig>('SHOWROOM_BTN_CONFIG');

export function provideShowroomConfig(config: ShowroomBtnConfig): Provider {
    return { provide: SHOWROOM_BTN_CONFIG, useValue: config };
}
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[showroomBtn]',
    standalone: true,
    host: {
        '[id]': 'btnId()',
    },
})
export class ShowroomBtnDirective {
    protected readonly store = inject(Store);
    protected readonly config = inject(SHOWROOM_BTN_CONFIG);

    dealer = this.store.selectSignal(DealerFeature.state.selectLoadedDealer);
    btnId = computed(() => `showroom-btn-${showroomBtns++}`);
    constructor() {
        if (isPlatformServer(inject(PLATFORM_ID))) {
            return;
        }
        this.initShowroomBtn();
    }

    async initShowroomBtn() {
        await injectScript(this.config.scriptUrl, {
            dataProsp: {
                call_element_id: this.btnId(),
                referral_name: `${this.dealer().name} ${this.dealer().name2} ${this.dealer().name3}`.trim(),
                referral_url: window.location.href,
                referral_id: this.dealer().id,
                location_id: '1',
            },
        });
        window.document.dispatchEvent(
            new Event('DOMContentLoaded', {
                bubbles: true,
                cancelable: true,
            }),
        );
    }
}
